import { CircularProgress } from "@mui/material";
import classNames from "classnames";
import * as PropTypes from "prop-types";
import * as React from "react";
import "./style.scss";

interface LoadingProps {
    verticalCenter?: boolean;
    loadingText?: boolean;
    loadingTextPlaceholder?: string;
    classes: any;
}

export class LoadingIndicator extends React.Component<LoadingProps, {}> {

    static defaultProps = {
        verticalCenter: false,
        loadingText: false,
        loadingTextPlaceholder: "Please wait",
        size: "large",
    };

    static propTypes = {
        verticalCenter: PropTypes.bool,
        loadingText: PropTypes.bool,
        size: PropTypes.string,
    };

    render() {
        return (
            <div className={classNames("loadingIndicator", {
                ["verticalCenter"]: this.props.verticalCenter,
            })}>
                <CircularProgress style={{ margin: 2 }} />
                {this.props.loadingText && <span className="initText">{this.props.loadingTextPlaceholder}</span>}
            </div>
        );
    }
}
